import { render, staticRenderFns } from "./ReportsGenerator.vue?vue&type=template&id=6bc8ad17&scoped=true"
import script from "./ReportsGenerator.vue?vue&type=script&lang=js"
export * from "./ReportsGenerator.vue?vue&type=script&lang=js"
import style0 from "./ReportsGenerator.vue?vue&type=style&index=0&id=6bc8ad17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8ad17",
  null
  
)

export default component.exports